export default "__VITE_ASSET__b8db5233__"